import * as React from "react";

export interface IInput2SearchHitsProps {
    hits: any[];
    selectedSearchHitIdx: number;
    itemPropNames?: string[];
    select?: (item) => void;
}

export const GInputSearchHits: React.FC<IInput2SearchHitsProps> = ({ hits, itemPropNames, selectedSearchHitIdx = 0, select }: IInput2SearchHitsProps) => {
    if (!hits || 0 == hits.length) {
        return null;
    }
    return (
        <div className="g-input-searchhits-wrap">
            <ul className="g-input-searchhits">
                {
                    hits.map((hit, idx) => {
                        const isSelected = idx == selectedSearchHitIdx;
                        return (
                            <li key={ idx }
                                className={ `g-input-searchhits__item ${ isSelected ? "g-input-searchhits__item--selected" : "" }` }
                                onMouseDown={ () => select(hit) }
                            >
                                { itemPropNames ? hit[itemPropNames[0]] : hit }
                            </li>
                        );
                    })
                }

            </ul>

        </div>
    );
};
